import { keepPreviousData, useQuery } from '@tanstack/react-query';

import TagsService, { GetTagAssociationsParams } from '~/services/TagsService';

export const tagAssociationQueryKeys = {
  all: ['tag-assignments', 'associations', 'entities'] as const,
  list: (params: GetTagAssociationsParams) => [...tagAssociationQueryKeys.all, params] as const,
};

export function useGetTagAssociations(params: GetTagAssociationsParams) {
  return useQuery({
    queryKey: tagAssociationQueryKeys.list(params),
    queryFn: ({ signal }) => TagsService.getTagAssociations(params, { signal }),
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
  });
}
